<template>
  <div class="bottom-navigation" :class="{'hidden' : isHidden}">
    <v-bottom-nav app fixed :value="true" height="60">
      <router-link to="/" class="btn">
        <v-btn :ripple="false" @click="toggleHome()" flat value="favorites" class="promotions-v2" :class="{'active': activeHome}">
          <icon name="icon-home"></icon>
          <span class="bottom_nav_text">Home</span>
        </v-btn>
      </router-link>
      <v-btn :ripple="false" @click="toggleMenu()" flat color="teal" value="recent" class="menu" :class="{'active': dialogSportsMenu}">
        <icon name="icon-sports-atoz"></icon>
        <span class="bottom_nav_text">{{ $t('Sports.Sports') }}</span>
      </v-btn>
      <!-- <v-btn :ripple="false" @click="toggleBetslip()" flat value="nearby" class="betslip-button" :class="{'active': dialogBetslip, 'hasSelections' : selectionsNo > 0}">
        <icon name="icon-betslip" background :colorName="selectionsNo > 0 || dialogBetslip ? 'white' : 'dark'"></icon>
        <span class="bottom_nav_text">Betslip</span>
        <badge v-if="selectionsNo > 0">{{selectionsNo}}</badge>
      </v-btn> -->
      <v-btn @click="specialLink()" v-if="navigationType">
        <icon :name="navigationName" :colorName="'dark'"></icon>
        <span class="bottom_nav_text">Promotions</span>
      </v-btn>
      <v-btn :ripple="false" v-if="isLoggedIn" @click="toggleMyAccount()" flat value="nearby" class="account" :class="{'active': dialogMyAccount}">
        <icon name="icon-user" :colorName="dialogMyAccount ? 'blue' : 'dark'"></icon>
        <span class="bottom_nav_text">{{ $t('MyAccount.Account') }}</span>
      </v-btn>
      <!-- <v-btn :ripple="false" v-if="!isLoggedIn" @click="toggleLogin()" flat value="nearby" class="account" :class="{'active': dialogMyAccount}">
        <icon name="icon-user" :colorName="dialogMyAccount ? 'blue' : 'dark'"></icon>
        <span class="bottom_nav_text" :class="dialogMyAccount ? 'blue' : ''">{{ $t('MyAccount.Account') }}</span>
      </v-btn> -->
    </v-bottom-nav>

    <v-navigation-drawer class="dialog-menu" v-if="mobileBigAndBelow" v-model="dialogSportsMenu" app fixed disable-resize-watcher disable-route-watcher>
      <div class="header">
        <v-layout class="title">
          <v-flex class="logo-wrapper">
            <logo v-if="!isLoggedIn"></logo>
            <logo v-if="isLoggedIn" mode="sign" ></logo>
          </v-flex>
          <v-flex v-if="isLoggedIn">
            <account-info-component></account-info-component>
          </v-flex>
          <v-flex class="close">
            <v-btn flat @click="toggleMenu()" class="close"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div class="curve"></div>
      <sports-menu></sports-menu>
    </v-navigation-drawer>
<!-- 
    <v-dialog content-class="dialog-betslip" v-if="mobileBigAndBelow" v-model="dialogBetslip" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
      <betslip></betslip>
    </v-dialog> -->
  </div>
</template>

<script>
  import store from '@/store'
  import config from '@/config'

  import Screen from '@/components/mixins/Screen'
  import Session from '@/components/mixins/Session'

  import Badge from '@/components/common/Badge'
  import SportsMenu from '@/components/sports/bettingoffer/SportsMenu'
  import HeaderInfo from '@/components/common/HeaderInfo'
  import Logo from '@/components/common/Logo'
  import Betslip from '@/components/sports/betslip/BetslipPage'
  import AccountInfoComponent from '@/components/horses/account/AccountInfoComponent'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'BottomNavigation',

    mixins: [
      Screen,
      Session
    ],

    components: {
      Badge,
      Logo,
      SportsMenu,
      Betslip,
      HeaderInfo,
      Icon,
      AccountInfoComponent
    },

    props: {
      text: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      sessionTime: 0,
      feedback: '',
      feedbackTo: null
    }),

    computed: {
      dateFormats () { return config.app.dateFormats },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      dialogSportsMenu: {
        get: function () {
          return store.getters['overlayState/getSportsMenuState']
        },
        set: function (value) {
          if (value) {
            store.dispatch('overlayState/activateSportsMenu')
          } else {
            store.dispatch('overlayState/deactivateSportsMenu')
          }
        }
      },

      dialogMyAccount () {
        return store.getters['overlayState/getMyAccountDialogState']
      },
      dialogBetslip () {
        return store.getters['overlayState/getBetslipState']
      },
      selectionsNo () {
        return store.getters['sbBetslipState/selectionsNo']
      },
      allowedReturnsPRL () {
        return store.getters['sbBetslipState/allowedReturnsPRL']
      },
      gettingABTnR () {
        return store.getters['sbBetslipState/gettingABTnR']
      },
      mobileFeedback () {
        return store.getters['sbBetslipState/mobileFeedback']
      },
      isFastBetEnabled () {
        return store.getters['sbBetslipState/isFastBetEnabled']
      },
      activeHome () {
        if (store.getters['overlayState/getMyAccountDialogState'] === false && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getSportsMenuState'] === false && this.$route.name === 'sports') {
          return true
        }
      },
      betSlipStatus () {
        return store.getters['sbBetslipState/betSlipStatus']
      },
      isHidden () {
        // store.getters['overlayState/getBetslipState'] === true
        if ((this.betSlipStatus.State === 2 && store.getters['overlayState/getBetslipState'] === true) ||
          store.getters['overlayState/getSingleBetslipState'].active === true ||
          store.getters['overlayState/getSportsMenuState'] === true ||
          store.getters['overlayState/getHamburgerMenuState'] === true ||
          store.getters['overlayState/getMessageDialogState'] === true ||
          store.getters['overlayState/getCompetitionSelectDialogState'] === true ||
          store.getters['overlayState/getBetslipMsg'].active === true ||
          (store.getters['overlayState/getBetslipConfirm'].active === true && store.getters['overlayState/getBetslipState'] === true) ||
          (store.getters['overlayState/getMyAccountDialogState'] === true && store.getters['isLoggedIn'] === false) ||
          store.getters['overlayState/getLoginDialogState'] === true) {
          return true
        }
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      navigationSections () {
        return store.getters['siteNavigationState/navigationSections']
      },
      navigationType () {
        if (this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL) {
          return (this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].display === 'ALWAYS') || (this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].display === 'LOGGEDIN' && this.isLoggedIn) || (this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].display === 'LOGGEDOUT' && !this.isLoggedIn)
        }
      },
      navigationName () {
        if (this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL) {
          return this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].cssclass
        }
      }
    },
    methods: {
      toggleMyAccount () {
        if (this.dialogMyAccount) {
          store.dispatch('overlayState/deactivateMyAccountDialog')
        } else {
          store.dispatch('overlayState/activateMyAccountDialog')
        }
      },
      toggleLogin () {
        store.dispatch('overlayState/activateMyAccountDialog')
      },
      toggleMenu () {
        if (this.dialogSportsMenu) {
          store.dispatch('overlayState/deactivateSportsMenu')
        } else {
          store.dispatch('overlayState/activateSportsMenu')
        }
      },

      toggleBetslip () {
        clearTimeout(this.feedbackTo)
        this.feedback = ''
        if (this.dialogBetslip) {
          store.dispatch('overlayState/deactivateBetslip')
        } else {
          store.dispatch('overlayState/activateBetslip')
        }
      },
      toggleBetslip4History () {
        clearTimeout(this.feedbackTo)
        this.feedback = ''
        if (this.$route.params && this.$route.params.hstate) {
          let hs = this.$route.params.hstate.toLowerCase()
          if (!this.isLoggedIn) hs = ''
          switch (hs) {
            case 'active':
            case 'settled':
              if (!this.dialogBetslip) {
                store.dispatch('overlayState/activateBetslip')
              }
              break
          }
        }
      },
      toggleHome () {
        store.dispatch('overlayState/deactivateBetslip')
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
      },
      specialLink () {
        if (this.isOpenedFromWebView) {
          window.location = this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].action + '?uiView=true'
        } else {
          window.location = this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].action
        }
      },
      showFeedBack () {
//        console.log('showFeedBack')
        this.feedback = this.$t('BetSlip.mobile.feedback.added')
        this.showParlayMsg()
      },
      showParlayMsg (d) {
//        console.log('showParlayMsg')
        var self = this
        d = d || self.mobileFeedback.timeOut
        clearTimeout(self.feedbackTo)
        self.feedbackTo = setTimeout(function () {
          if (!self.gettingABTnR) {
            if (self.allowedReturnsPRL && self.allowedReturnsPRL.PotentialReturn) {
              var stake = self.mobileFeedback.stake
              var win = (stake * self.allowedReturnsPRL.PotentialReturn - stake)
              // self.feedback = self.$gettext('BetSlip.mobile.feedback.playParlay')
              // self.feedback = self.$gettextInterpolate(self.feedback, {
              //   stake: stake.toFixed(2),
              //   n: self.selectionsNo,
              //   win: win.toFixed(2)
              // })
              self.feedback = self.$t('BetSlip.mobile.feedback.playParlay', {
                stake: stake.toFixed(2),
                n: self.selectionsNo,
                win: win.toFixed(2)
              })
              if (self.mobileFeedback.autoHidePrlMsgAfter) {
                self.clearFeedback(self.mobileFeedback.autoHidePrlMsgAfter)
              }
            } else {
              self.clearFeedback(0)
            }
          } else {
            self.showParlayMsg(1)
          }
        }, d * 1000)
      },
      clearFeedback (d) {
        d = d || 0
//        console.log('clearFeedback in ' + d)
        var self = this
        clearTimeout(self.feedbackTo)
        self.feedbackTo = setTimeout(function () {
          self.feedback = ''
        }, d * 1000)
      }
    },

    watch: {
      selectionsNo (newVal, oldVal) {
//        console.log('auto toggle betslip')
        clearTimeout(this.feedbackTo)
        this.feedback = ''
        if (!this.dialogBetslip && newVal === 1 && oldVal === 0 && !this.isFastBetEnabled) {
          setTimeout(function () {
            store.dispatch('overlayState/activateBetslip')
          }, 0)
        } else if (newVal > 1 && newVal > oldVal) {
          this.showFeedBack()
        }
      },
      isLoggedIn (newVal, oldVal) {
        if (newVal === true) {
          this.toggleBetslip4History()
        }
      }
    },

    created () {
      setInterval(() => {
        let value = Math.round(Math.abs(localStorage.loginTime - Date.now()) / 1000)
        if (value >= 0) {
          let minutes = Math.floor(value / 60)
          let seconds = value - minutes * 60
          seconds = (seconds < 10 ? ('0' + seconds) : seconds)
          minutes = (minutes < 10 ? ('0' + minutes) : minutes)
          this.sessionTime = `${minutes}:${seconds}`
        }
      }, 1000)

      this.toggleBetslip4History()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/css/config"
  @import "fonts";

  .bottom-navigation
    &.hidden
      .navigation-drawer
        max-height: 100% !important
      .bottom-nav
        display: none

  .header
    padding-top 0
    .title
      padding-top 21px
  .session-info
    font-size 10px
  .bottom-navigation
    .bottom-nav
      z-index: 9999

      .btn
        filter: none
        padding: 0
        min-width: 50px
        opacity: 1
        position: relative
        display: block

        >>> .btn__content
          padding: 0
          flex-direction column !important
          font-weight normal

          &:before
            display: none

          i.icon
            margin: 0

        .badge
          background-color: #e44242
          color: #fff
          position: absolute
          font-size: 12px
          font-weight: normal
          top: -2px
          margin-left: 12px

        .betslip_mobile_msg
          position: absolute
          bottom: 65px
          width: 320px
          height: 28px
          p
            display: inline-block
            background: #2396FC
            color: #ffffff
            padding: 5px 10px
            max-width: 320px
            overflow hidden
            white-space: normal
            border-radius: 5px
            height: 28px
            &:after
              material-icons()
              display: block
              content: 'arrow_drop_down'
              margin: auto
              line-height: 0px
              font-size: 30px
              color: #2396FC
              position: absolute
              bottom: 0
              left: 50%
              margin-left: -15px
              z-index: 1000

      >>> .igt-icon:not(.background)
          height: 33px
          display: flex
          align-items: center

      >>> .igt-icon
        &.background
          width: 33px
          height: 33px

        > span
          width: 17px
          height: 17px

    .betslip-button
      >>> .igt-icon
        &.background
          background-color: #F0F3F8

      &.active
        >>> .igt-icon
          &.background
            background-color: #2396FC

      &.hasSelections
        >>> .igt-icon
          &.background
            background-color: #1493ff

.bottom_nav_text
  font-size 10px  
  color #99a8b1
  padding-top 1px

  /* iphone XS */
.os-ios
  @media only screen and (min-device-width: 375px) and (min-device-height: 812px) and (-webkit-min-device-pixel-ratio: 3)
    .bottom-nav
      height 94px !important
      padding-bottom 34px
      // padding-top 5px      
  /* iphone XS Max */
.os-ios
  @media only screen and (min-device-width: 414px) and (min-device-height: 896px) and (-webkit-min-device-pixel-ratio: 3)
    .bottom-nav
      height 94px !important
      padding-bottom 34px
      // padding-top 5px
  /* iphone XR */
.os-ios
  @media only screen and (min-device-width: 414px) and (min-device-height: 896px) and (-webkit-min-device-pixel-ratio: 2)
    .bottom-nav
      height 94px !important
      padding-bottom 34px
      // padding-top 5px
.close
  flex-grow: 0
  @media mobile-big-and-below
    display: block

  .btn
    min-width: 0
    position: absolute
    top: -17px
    right: -8px
    width: 24px
    height: 24px
    .icon
      font-weight: normal
      font-size: 26px !important
    >>>.btn__content
      padding: 0

</style>



// WEBPACK FOOTER //
// src/components/layout/parts/BottomNavigation.vue